import { render, staticRenderFns } from "./InviraRolesCrud.vue?vue&type=template&id=0c31cc53&scoped=true"
import script from "./InviraRolesCrud.vue?vue&type=script&lang=js"
export * from "./InviraRolesCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c31cc53",
  null
  
)

export default component.exports